module.exports = __webpack_public_path__ + "static/img/windows_FAQ_pic04.6554728.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/windows_FAQ/windows_FAQ_pic04.jpg
// module id = 601
// module chunks = 1